import { mapState } from "vuex";

export default {
  name: 'NormalizerLocationsMixin',

  data() {
    return {
      valueLocations: null,
    }
  },

  computed: {
    ...mapState("findings", ["locations"]),
  },

  methods: {
    /**
     * Normalizador reusable para Treeselect
     * Retorna una función normalizadora para usar en :normalizer
     */
    normalizerLocations(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
  }
} 